import imgLogoHeader from '../assets/image/logo_kalbe_kalpanax.png';
import iconLogin from '../assets/icon/icon_login.svg';
import iconLogout from '../assets/icon/icon_logout.svg';
import Button from './button';
import { useContext, useEffect, useState } from 'react';
import FormLogin from './formLogin';
import { useNavigate } from 'react-router-dom';
import { ProfileContext } from './context/profileContext';
import Cookies from 'js-cookie';
import useIsLoginPath from './hook/useIsLoginPath';

const Header = (props) => {
  const isLoginPath = useIsLoginPath();
  const { profile, setProfile } = useContext(ProfileContext);
  const navigate = useNavigate();
  const [showLogin, setShowLogin] = useState(false);

  const handleLogout = () => {
    Cookies.remove('auth_token');
    setProfile(null);
    navigate('/sales');
  };

  return (
    <header className="relative flex justify-between items-center bg-white h-12 md:h-20 rounded-xl md:rounded-3xl p-2.5 md:px-5 md:py-4">
      {showLogin && <FormLogin onClose={() => setShowLogin(false)} />}

      <img
        onClick={() => navigate('/')}
        src={imgLogoHeader}
        alt="kalbe - kalpanax"
        className="cursor-pointer object-contain h-7 md:h-12"
      />

      {profile ? (
        <div className="flex space-x-2 justify-center items-center">
          <div className="w-max">
            <Button
              bold
              label="Keluar"
              icon={iconLogout}
              onClick={() => handleLogout()}
            />
          </div>
          <div
            onClick={() => navigate('/profile')}
            class="cursor-pointer w-8 h-8 md:w-12 md:h-12 rounded-full bg-borderGray border-2 md:border-4 border-borderDarkGray flex justify-center items-center text-xl md:text-3xl text-white font-semibold">
            {profile?.name[0]}
          </div>
        </div>
      ) : isLoginPath ? (
        <div className="w-max">
          <Button
            bold
            label="Masuk"
            icon={iconLogin}
            onClick={() => setShowLogin(!showLogin)}
          />
        </div>
      ) : <></>}
    </header>
  );
};

export default Header;
